// AgentModelSelect — dropdown de modelo do popup do agente (pedido 2026-07-10):
// em vez de input livre + datalist, um <select> com as LLMs DISPONÍVEIS no
// adapter selecionado. O input livre continua existindo como escape hatch
// ("Outro (digitar)…") — modelo custom é decisão deliberada (Ollama tags, ids
// novos que o registry ainda não conhece) e um agente editado NUNCA perde o
// modelo salvo: valor fora da lista vira option.
import { useState } from 'react';

const CUSTOM = '__custom__';

export default function AgentModelSelect({ value, options, onChange, mismatch = false }) {
  const list = Array.isArray(options) ? options.filter(Boolean) : [];
  // Começa no input livre quando não há o que listar; senão select.
  const [customMode, setCustomMode] = useState(list.length === 0);

  const inputClass = `w-full rounded-md border bg-apolo-surface2 px-2 py-1 text-xs font-mono focus:outline-none focus:ring-2 ${
    mismatch
      ? 'border-apolo-warning focus:border-apolo-warning focus:ring-apolo-warning/30'
      : 'border-apolo-border focus:border-apolo-accent focus:ring-apolo-accentRing'
  }`;

  if (customMode || list.length === 0) {
    return (
      <div className="flex items-center gap-1">
        <input
          aria-label="Modelo do agente (digitar)"
          type="text"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder="provider/modelo ou tag local"
          className={inputClass}
        />
        {list.length > 0 && (
          <button
            type="button"
            onClick={() => setCustomMode(false)}
            className="shrink-0 text-[10px] text-apolo-textTertiary transition hover:text-apolo-textPrimary"
            title="Voltar pra lista de modelos disponíveis"
          >
            lista
          </button>
        )}
      </div>
    );
  }

  // Valor salvo fora da lista entra como option — nunca some ao editar.
  const withValue = value && !list.includes(value) ? [value, ...list] : list;
  return (
    <select
      aria-label="Modelo do agente"
      value={value || ''}
      onChange={(e) => {
        if (e.target.value === CUSTOM) setCustomMode(true);
        else onChange(e.target.value);
      }}
      className={inputClass}
    >
      {withValue.map((m) => (
        <option key={m} value={m}>{m}</option>
      ))}
      <option value={CUSTOM}>Outro (digitar)…</option>
    </select>
  );
}
